<div class="flag" [class.modified]="modified" [class.disabled]="isDisabled" [class.warning]="hasWarning">
  <div class="flag-name-wrapper">
    <span *ngIf="modified" class="flag-dot" appTooltip text="Flag has been modified."></span>
    <span class="flag-name">{{ key }}</span>
    <ng-container *ngIf="helpText">
      <app-help-icon [class.link]="jiraLink" height="18px" width="18px" appTooltip [text]="helpText"
        [color]="helpIconColor" (click)="goToJiraIssue()" />
    </ng-container>
    <div *ngIf="isDisabled" appTooltip [text]="disabledToggleFlags[key]">
      <app-warning-icon height="18px" width="18px" color="#f57c00" />
    </div>
    <div *ngIf="hasWarning" appTooltip [text]="warningFlagInfo[key]">
      <app-alert-icon height="16px" width="16px" shape="circle" color="#E71316" />
    </div>
  </div>
  <core-toggle class="flag-toggle" label="" [disabled]="isDisabled" [checked]="active" (onChange)="onToggle()"
    appTooltip [text]="disabledToggleFlags[key] || warningFlagInfo[key]" />
</div>
